/**
 * A full name as a bag of words: accents, case, punctuation and word order
 * folded away. "ROMERO" / "MANZO, MARGARITA" and "MARGARITA" / "ROMERO MANZO"
 * are the same person split two ways.
 */
export const nameWords = (...parts) => parts
  .filter(Boolean)
  .join(' ')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .split(/[^\p{L}\p{N}]+/u)
  .filter(Boolean)
  .sort()
  .join(' ');

export default nameWords;
